<template>
  <div class="w-full flex flex-col border border-border-normal p-4" style="border-radius: 20px;">
    <!-- Creator and Submission Date -->
    <div class="w-full flex items-center justify-between">
      <div class="flex items-center gap-2">
        <img :src="submission.creator.avatar" class="w-5 h-5 rounded-full" />
        <BaseText type="label" size="sm" class="text-text-muted">
          {{ submission.creator.name }}
        </BaseText>
        <BaseText type="body" size="sm" class="text-text-normal">
          {{ submission.creator.handle }}
        </BaseText>
      </div>
      <div class="flex items-center gap-1 px-2 py-1 rounded-lg bg-neutral-10">
        <DueDateIcon class="text-icon-normal" />
        <BaseText type="body" size="sm" class="text-text-normal">
          Submitted {{ formattedSubmitDate }}
        </BaseText>
      </div>
    </div>
    <!-- divider -->
    <div class="w-full h-0 my-4 border-b border-border-normal" />
    <!-- Submission Content -->
    <a :href="submission.postUrl" target="_blank" class="mb-2 hover:underline">
      <BaseText type="label" size="sm" class="text-text-muted truncate">
        {{ submission.postUrl }}
      </BaseText>
    </a>
    <!-- Social Post Embed -->
    <XEmbed 
      v-if="submission.socialPlatform === 'twitter'" 
      :post-url="submission.postUrl" 
      :options="{ align: 'center' }"
    />
    <LinkedInEmbed 
      v-if="submission.socialPlatform === 'linkedin'" 
      :post-url="submission.postUrl" 
    />
  </div>
</template>

<script>
import moment from 'moment'
import XEmbed from './XEmbed.vue'
import LinkedInEmbed from './LinkedInEmbed.vue'

import DueDateIcon from '../globals/Icons/DueDateIcon.vue'

export default {
  name: 'BountySubmissionCard',
  components: {
    XEmbed,
    LinkedInEmbed,
    DueDateIcon
  },
  props: {
    submission: {
      type: Object,
      required: true
    }
  },
  computed: {
    formattedSubmitDate () {
      return moment(this.submission.submitDate).format('MMM DD')
    }
  }
}
</script>